import { protectedGet } from "./restUtil";
import moment from "moment-timezone";
import type { ServerErrorResponse } from "services/errors";

export const NotificationTaskType = {
  FEEDBACK: "feedback-task",
  PLAN: "plan-task",
} as const;

export type Task = {
  due_date: string;
  scheduled: string;
  type: string;
  session?: {
    id: string;
    scheduled: string;
    user: {
      id: string;
      first_name: string | null;
      last_name: string | null;
    };
  };
  user?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
  };
};

function createInvalidResponseError(): ServerErrorResponse {
  return {
    errors: [
      {
        description: "invalid response structure",
      },
    ],
  };
}

export function fetchTasksNumber(
  _args: void,
  onSuccess: (count: number) => void,
  onError: (error: ServerErrorResponse) => void
) {
  return protectedGet(
    "/tasks/count",
    undefined,
    (resp: { count?: number }) => {
      if (!resp || resp.count === undefined) {
        return onError && onError(createInvalidResponseError());
      }
      return onSuccess && onSuccess(resp.count);
    },
    onError
  );
}

export function fetchTasks(
  _args: void,
  onSuccess: (response: { list: Task[] }) => void,
  onError: (error: ServerErrorResponse) => void
) {
  return protectedGet(
    "/tasks",
    undefined,
    (resp: { list?: Task[] }) => {
      if (!resp || resp.list === undefined) {
        return onError && onError(createInvalidResponseError());
      }
      return onSuccess && onSuccess({ list: resp.list });
    },
    onError
  );
}

export function isTaskOverdue(task: Task) {
  return moment.utc().isAfter(task.due_date);
}
